import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TimesheetsWidget } from './timesheets.widget';

const routes: Routes = [
    {
        path: '',
        component: TimesheetsWidget,
    },
];


@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TimesheetsRoutingModule { }
